import React from 'react';
import PropTypes from 'prop-types';
import $ from "jquery";
import Loading from "shared/loading";
import successToast from "../utilities/success_toast";
import MoveForm from "shared/virtual_line_modal/components/MoveForm";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ModalButtonRow from "../components/ModalButtonRow";
import PromoNumberLabel from "./PromoNumberLabel";

export default class MoveModal extends React.Component {
  state = {
    isOpen: true
  };

  static propTypes = {
    virtualLineMover: PropTypes.object.isRequired,
    successCallback:  PropTypes.func.isRequired
  };

  modalRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return { virtualLineMover: props.virtualLineMover };
  }

  render() {
    const { isOpen, virtualLineMover } = this.state;

    return (
      <div ref={this.modalRef}>
        <Modal isOpen={isOpen} toggle={this.toggleModal} className="modal-force-light">
          <ModalHeader toggle={this.toggleModal}>Move Promo Number</ModalHeader>

          <ModalBody>
            <MoveForm
              virtualLineMover={virtualLineMover}
              updateForm={this.updateVirtualLineMover}
            >
              <PromoNumberLabel phoneNumber={virtualLineMover.sourceVirtualLines[0].name} />
            </MoveForm>
          </ModalBody>

          <ModalFooter>
            <ModalButtonRow
              toggle={this.toggleModal}
              submitAction={this.onMove}
              errorMessage={virtualLineMover.errorMessages()}
              valid={virtualLineMover.valid()}
            />
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  toggleModal = () => {
    this.setState({ isOpen: false });
  }

  updateVirtualLineMover = (virtualLineMover) => {
    virtualLineMover.validate();
    this.setState({ virtualLineMover });
  }

  onMove = () => {
    const { virtualLineMover } = this.state;
    if (virtualLineMover.valid()) {
      Loading.show($(this.modalRef.current));
      virtualLineMover.save(this.onRequestSuccess, this.setErrorAndRender);
    } else {
      this.updateVirtualLineMover(virtualLineMover);
    }
  }

  onRequestSuccess = (model, destinationParams, errors) => {
    const { virtualLineMover } = this.state;
    this.successToast(virtualLineMover, destinationParams, errors);

    this.props.successCallback(model);
    this.toggleModal();
  }

  successToast(virtualLineMover, destinationParams) {
    successToast(virtualLineMover.validSourceNumbers()[0], destinationParams);
  }

  setErrorAndRender = (errorMessages) => {
    Loading.hide();
    this.updateToInvalid(errorMessages);
  }

  updateToInvalid(errorMessages) {
    const { virtualLineMover } = this.state;
    virtualLineMover.setServerErrors(errorMessages);
    this.updateVirtualLineMover(virtualLineMover);
  }
}
